module.exports = __webpack_public_path__ + "img/lunas.301036ef.png";